import { render } from "./PartnerReportsPage.vue?vue&type=template&id=8eb173dc"
import script from "./PartnerReportsPage.vue?vue&type=script&lang=js"
export * from "./PartnerReportsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__